const TopBar = {
  setSwiperTopBar: function () {
    const topBar = document.querySelector('[data-top-bar]');

    if (topBar) {
      const slider = new Swiper(topBar, {
        slidesPerView: 1,
        preloadImages: false,
        speed: 1000,
        autoplay: true,
        lazy: {
          checkInView: true,
          loadPrevNext: true,
          loadOnTransitionStart: true,
          loadPrevNextAmount: 4,
        },
      });

      slider.autoplay.pause();
      function startSwiper() {
        window.removeEventListener('scroll', startSwiper);
        window.removeEventListener('mousemove', startSwiper);
        slider.autoplay.start();
        slider.autoplay.run();
      }
      window.addEventListener('scroll', startSwiper);
      window.addEventListener('mousemove', startSwiper);
    }
  },

  init: function () {
    const _this = this;

    _this.setSwiperTopBar();
  },
};

export default TopBar;
